import { app } from '@/config/firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { CapabilityScoreDebug, CandidateScoreDebug } from '../models/availability.types';

const functions = getFunctions(app, 'us-central1');

export interface MatchSuggestion {
  collaboratorId: string;
  fullName: string;
  avatarUrl: string | null;
  scoreTotal: number;
  contract: {
    lastType: string | null;
    normalizedSalary: number | null;
  };
  location: {
    city: string | null;
    state: string | null;
  };
  scores: {
    financial: number;
    availability: number;
    location: number;
    capabilities: number;
  };
  assumptions: {
    salaryMissing: boolean;
    salaryLimitMissing: boolean;
    availabilityMissing: boolean;
    locationFallback: boolean;
    optionalAutoFulfilled: boolean;
  };
  capabilityDebug?: CapabilityScoreDebug;
  debug?: CandidateScoreDebug;
  inputs: {
    normalizedSalary?: number | null;
    limitSalary?: number | null;
    lastContractType?: string | null;
    loadMonthly?: number | null;
    nextAvailabilityDate?: string | null;
    workModelPreferences?: string[];
    capabilityMatches?: unknown[];
    [key: string]: unknown;
  };
}

export interface RunSlotMatchPayload {
  availabilityId?: string;
  slotId?: string;
  limit?: number;
  page?: number;
  scoreCutoff?: number | null;
  segmentCutoffs?: Partial<Record<'financial' | 'availability' | 'location' | 'capabilities', number | null>>;
  slot?: Record<string, unknown>;
}

export interface RunSlotMatchResponse {
  suggestions: MatchSuggestion[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export async function runAvailabilitySlotMatch(payload: RunSlotMatchPayload): Promise<RunSlotMatchResponse> {
  const callable = httpsCallable<RunSlotMatchPayload, RunSlotMatchResponse>(
    functions,
    'runAvailabilitySlotMatch'
  );

  const response = await callable(payload);
  return response.data;
}
